import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Box
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useThemeMode } from "../theme/ThemeContextProvider";
import { APP } from "../constants";
import { useAppConfig } from "../context/ConfigContext";

const TopBar = ({ onToggleSidebar }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const { logout, fullName } = useAuth();
  const { mode, toggleTheme } = useThemeMode();

  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleLogout = () => logout();
  const { clientName, logo } = useAppConfig();

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        boxShadow: 2,
        height: 56,
      }}
    >
      <Toolbar
        sx={{
          minHeight: 56,
          px: 1,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {/* Left side: Logo + App name */}
        <Box display="flex" alignItems="center" gap={1}>
          <IconButton edge="start" color="inherit" onClick={onToggleSidebar} sx={{ p: 0.5 }}>
            <MenuIcon />
          </IconButton>
          <img src={logo} alt="Logo" style={{ height: 32, marginRight:5 }} /> {/* change to your logo path */}
          <Typography variant="h6" noWrap>
            {/* {APP.NAME} */}
            {clientName}
          </Typography>
        </Box>

        {/* Right side: Theme switch + Avatar */}
        <Box display="flex" alignItems="center">
          <IconButton onClick={toggleTheme} color="inherit">
            {mode === "light" ? <Brightness4 /> : <Brightness7 />}
          </IconButton>
          <IconButton onClick={handleMenuClick} size="small" sx={{ ml: 1 }}>
            <Avatar sx={{ width: 32, height: 32 }}>
              {fullName?.charAt(0) || 'A'}
            </Avatar>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 3,
              sx: {
                mt: 0,
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 6px rgb(0, 0, 0))',
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            {/* <MenuItem onClick={() => navigate("/profile")}>Profile</MenuItem>
            <MenuItem onClick={() => navigate("/settings")}>Settings</MenuItem> */}
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
